import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import { catchHttpError } from '../utils/catch-http-error';
import {
    AcknowledgeMessage,
    AcknowledgeMessageFailure,
    AcknowledgeMessageSuccess,
    LoadMessages,
    LoadMessagesActionTypes,
    LoadMessagesFailure,
    LoadMessagesSuccess
} from './actions';
import { MessagingService } from './service';

@Injectable()
export class MessagingEffects {
    private actions$ = inject(Actions);
    private service = inject(MessagingService);

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    constructor() {}

    loadMessagesEffects$ = createEffect(() =>
        this.actions$.pipe(
            ofType<LoadMessages>(LoadMessagesActionTypes.LOAD_MESSAGES),
            mergeMap(() =>
                this.service.getPendingMessages().pipe(
                    map(messages => new LoadMessagesSuccess(messages)),
                    // A 403 here just means the tenant does not have the feature. The reducer
                    // folds this into an empty list rather than an error state.
                    catchHttpError(error => of(new LoadMessagesFailure({ error })))
                )
            )
        )
    );

    acknowledgeMessageEffects$ = createEffect(() =>
        this.actions$.pipe(
            ofType<AcknowledgeMessage>(LoadMessagesActionTypes.ACKNOWLEDGE_MESSAGE),
            // mergeMap, not switchMap: acknowledgements are independent writes, and clicking
            // through a queue of messages quickly must not cancel the earlier ones in flight.
            mergeMap(action =>
                this.service.acknowledgeMessage(action.payload.id).pipe(
                    map(() => new AcknowledgeMessageSuccess({ id: action.payload.id })),
                    catchHttpError(error =>
                        of(new AcknowledgeMessageFailure({ id: action.payload.id, error }))
                    )
                )
            )
        )
    );
}
